import { DefaultDeviceWidth } from '@maxpreps/shared/styles/breakpoint';
import { DeviceType } from './requestContextUtils';

const getResponsiveContextValue = (hasMounted, deviceType) => {
  if (hasMounted) return;

  return {
    width:
      deviceType === DeviceType.Mobile
        ? DefaultDeviceWidth.Mobile
        : deviceType === DeviceType.Tablet
        ? DefaultDeviceWidth.Tablet
        : DefaultDeviceWidth.Desktop
  };
};

export default getResponsiveContextValue;
